<template>
  <div class="exemptionconfig">
    <h3>{{ name }}</h3>
    <!--标题-->
    <ul>
      <h4>{{ explain }}</h4>
      <!--说明-->
      <li v-for="(item, index) in list" :key="index">
        &nbsp;&nbsp; &nbsp;&nbsp;{{ index + 1 }}、{{ item.text }}
      </li>
      <!--遍历说明项-->
    </ul>
    <div class="endexplain">
      <h6>更新于{{ end }}</h6>
      <!--{结束项| dataFormat('YYYY-MM-DD')}-->
    </div>
  </div>
</template>
<script >
export default {
  name: "Exemptionconfig",
  data() {
    return {
      name: "免责声明",
      explain: "oopvr.com 以下称为“本站”。",
      list: [
        {
          text: "本站文章（包括投稿和转载文章）的版权仅归原作者所有，若作者有版权声明的或文章从其它网站转载而附带有原所有站的版权声明者，其版权归属以附带声明为准。",
        },
        {
          text: "转载文章来源均为其它媒体博客网站的文章，我们会尽可能注明出处及链接，但不排除来源不明的情况。转载是处于提供更多信息以参考使用或学习、交流之目的，不用于商业用途。转载无意侵犯版权，如转载文章涉及您的权益等问题，请作者速告知，我们将尽快处理。来信:oopvr@oopvr.com。",
        },
        {
          text: "本站所转载文章和网友投稿等内容纯属作者个人观点，仅供大家参考，并不代表本站同意其观点和对其真实性负责。读者用户据此操作，风险自担。如对本文内容有疑义，请及时与我们联系。",
        },
        {
          text: "本站所有内容,任何组织和个人不得盗链本站资源或者在非本站所属的服务器上建立镜像。",
        },
        {
          text: "本站在线服务中所显示的信息或资料的准确性、内容、完整性、合法性、可靠性、可操作性或可用性不承担任何责任。其他一切因使用本网站而引致之任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的损失，本网站概不负责，亦不承担任何法律责任。",
        },
        {
          text: "在网站应用中，由用户发表的评论仅代表用户本人观点，与本站立场无关。",
        },
        {
          text: "网站用户之间通过本网站相识、交往中所发生或可能发生的任何心理、生理上的伤害和经济上的损失，本站不承担任何责任。",
        },
        {
          text: "任何组织和个人如发现本站对搜索或链接的内容有侵犯他人权利的，敬请立即通知我们，我们将在第一时间予以更改或删除。",
        },
        {
          text: "凡以任何方式登录本站或直接、间接使用本站资料者，视为自愿接受本站声明的约束。本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。 ",
        },
      ],
      end: "2019年10月05日",
    };
  },
};
</script>
<style lang='less' scoped>
.exemptionconfig {
  padding: 15px 0;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  background-color: rgba(44, 88, 155, 0.1);
  border-radius: 3% 3% 3% 3%;
  box-shadow: 10px 10px 5px #bdbdbd;
  h3 {
    line-height: 50px;
  }
  ul {
    h4 {
      margin-left: 5px;
      text-align: left;
    }
    li {
      text-align: left;
      padding-left: 15px;
      margin-top: 20px;
    }
  }
  .endexplain {
    right: 50px;
    padding: 30px 30px;
    // background-color: dodgerblue;
    h6 {
      text-align: right;
      margin-right: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bottonconfig/exemptionconfig.vue